import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Alert, Dimensions } from 'react-native';
import { ref } from '@dbk-legacy/muster/utils';
import { createContainer } from '@dbk-legacy/muster/react';

import ScrollableLayout from '../../../components/common/scrollable-layout';
import SortingHeader from '../../../components/common/sorting-header';
import { LoadingCircle } from '../../../components/common/loading';

import PortfolioTable from './portfolio-table';
import PortfolioHeader from './portfolio-header';
import PortfolioCharts from './portfolio-charts';
import Error from '../../../components/common/error';
import IsNonActivePortfolio from './inacitve-portfolio';
import PaymentLimit from './payment-limit';
import envconfig from '../../../../db-env-build';
import { EBANKINGWEBLUX } from '../../../constants';

class Portfolio extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedPorfolioItem: null,
      scrollable: true
    };

    this.handleAssetSelected = this.handleAssetSelected.bind(this);
    this.gotoIncomeHistory = this.gotoIncomeHistory.bind(this);
    this.handleCircularBarClick = this.handleCircularBarClick.bind(this);

    // this.props.clearData();
    setTimeout(() => {
      this.getData();
    }, 100);

  }


  async getData() {
    await this.props.getData();
   // this.props.auth.showPaymentLimitAvailable(); /* Remove payment limit msg */
  }

  componentWillMount() {
    this.props.ui.state.portfolio.resetSort();

  }

  componentWillReceiveProps(nextProps) {

    if ((nextProps.portfolio.id != this.props.portfolio.id) ||
      (nextProps.portfolio.id == this.props.portfolio.id && nextProps.user.selectedPortfolioData.relId != this.props.user.selectedPortfolioData.relId)) {
      this.getData();
    }
  }


  componentDidMount() {
    this.props.search.clearSearchFilters();
    if(document.querySelector('.logo-web')){
      document.querySelector('.logo-web').focus();
    }
  }

  handleAssetSelected(asset) {
    if (this.props.onSelectAsset) {
      this.props.onSelectAsset(asset);
    }
  }


  gotoIncomeHistory() {
    console.log("gotoIncomeHistory");
    const { rsaAuthorised } = this.props.rsa;
    const { user, i18n: { messages } } = this.props;
    if (user.selectedPortfolioData.relId != null) {
      alert(messages['app.portfolio.circularChart.selPort']);
      // this.props.rsaChangePage('/portfolios/income-history');
      // this.props.changePage('/portfolios/income-history');
    } else {
      this.props.rsaChangePage('/portfolios/income-history');
      // this.props.changePage('/portfolios/income-history');
    }
  }

  handleCircularBarClick(newIndex, selectedItem) {
    this.setState(
      {
        selectedPorfolioItem: selectedItem,
      },
      () => {
        // todo: this is very slow and i don't think we need it any more
        // this.props.ui.state.portfolio.chartAssets.setSelected(newIndex);
      }
    );
    // this.props.ui.state.portfolio.chartAssets.setSelected(newIndex);
  }

  /* WMCE-4427 Disable payment limit popup 
  disablePaymentAlert = () => {
    this.props.user.profile.setShowPmtTxLimitMsg(false);
  }
  */

  render() {
    const {
      portfolio,
      ui,
      user,
      auth: { isNonActivePortfolio },
      screen,
      i18n: { messages }
    } = this.props;

    const state = ui.state.portfolio;
    let selectedView = state && state.view && state.view.selectedId || null;

    if (!selectedView) return null;
    if (!screen.isSmall) {
      selectedView = 'chart-table';
    }

    if (this.props.portfolio.busymode == true) {
      return (
        <div className="portfolio-container portfolio-ldng-crcle">
          <LoadingCircle isPage />
        </div>

      );
    }

    const renderScrollableLayout = props => (
      <div className="portfolio-container">
        <ScrollableLayout
          testID="portfolio-view"
          header={(
            <PortfolioHeader
              portfolio={portfolio}
              portfolios={user.portfolios}
              state={state}
              onPressNetIncome={this.gotoIncomeHistory}
              changePortfolio={user.setSelectedPortfolioId}
              screen={screen}
              messages={messages}
              portfolioChartYTD={JSON.parse(portfolio.portfoliosYTDData)}
              location = {ui.history.currentLocation.pathname}
            />
          )}
          scrollable={this.state.scrollable}
          {...props}
        />
        {/* {isNonActivePortfolio && <IsNonActivePortfolio />}
        {!isNonActivePortfolio && user.profile.showPmtTxLimitMsg && user.profile.paymentTxLimit && envconfig.envConfig !== EBANKINGWEBLUX && <PaymentLimit messages={messages} isPaymentLimit={user.profile.paymentTxLimit} disableAlert={this.disablePaymentAlert} />} */}
      </div>
    );

    if (selectedView === 'chart') {
      return renderScrollableLayout({
        body: (
          <PortfolioCharts
            portfolio={portfolio}
            portfolios={user.portfolios}
            selectedPortfolioData={user.selectedPortfolioData}
            portfoliosData={user.portfoliosData}
            changePortfolio={user.setSelectedPortfolioId}
            changePortfolioData={user.setSelectedPortfolioData}
            clearData={portfolio.clearData}
            changePage={ui.history.push}
            currency={portfolio.referenceCurrency}
            cumulativeData={portfolio.performanceLineChartData}
            barchartData={portfolio.performanceChartData}
            currencyChartData={portfolio.currencyExposure}
            screen={screen}
            messages={messages}
            onCircularBarClick={this.handleCircularBarClick}
            selectedPorfolioItem={this.state.selectedPorfolioItem}
            portfolioChartYTD={JSON.parse(portfolio.portfoliosYTDData)}
            commonCurrency={user.selectedPortfolio.referenceCurrency}
          />
        ),
      });
    } else if (selectedView === 'chart-table') {
      return renderScrollableLayout({
        body: (
          <PortfolioCharts
            portfolio={portfolio}
            portfolios={user.portfolios}
            selectedPortfolioData={user.selectedPortfolioData}
            portfoliosData={user.portfoliosData}
            changePortfolio={user.setSelectedPortfolioId}
            changePortfolioData={user.setSelectedPortfolioData}
            clearData={portfolio.clearData}
            changePage={ui.history.push}
            currency={portfolio.referenceCurrency}
            static={ui.static.portfolio}
            options={ui.static.portfolio.options}
            cumulativeData={portfolio.performanceLineChartData}
            barchartData={portfolio.performanceChartData}
            currencyChartData={portfolio.currencyExposure}
            state={state}
            screen={screen}
            selectedPorfolioItem={this.state.selectedPorfolioItem}
            messages={messages}
            onCircularBarClick={this.handleCircularBarClick}
            portfolioChartYTD={JSON.parse(portfolio.portfoliosYTDData)}
            commonCurrency={user.selectedPortfolio.referenceCurrency}
          />
        )
      });
    }
    return renderScrollableLayout({
      stickyHeader: (
        <SortingHeader
          currency={portfolio.referenceCurrency}
          options={ui.static.portfolio.options}
          state={state}
          messages={messages}
          enabled
        />
      ),
      body: (
        <PortfolioTable
          static={ui.static.portfolio}
          selectedPorfolioItem={this.state.selectedPorfolioItem}
          portfolio={portfolio}
          changePage={ui.history.push}
          messages={messages}
        />
      ),
    });

  }
}

Portfolio.propTypes = {
  changePage: PropTypes.func,
  portfolio: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  ui: PropTypes.shape({
    state: PropTypes.shape({
      portfolio: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
};

export default createContainer({
  $renderError: () => <Error />,
  $renderLoading: () => <div className="portfolio-ldng-crcle"><LoadingCircle isPage /></div>,
  $queries: {
    rsaChangePage: { '$call': 'rsa.changePage' },
    changePage: { $call: 'ui.history.push' },
    getData: { $call: 'portfolio.getData' },
    clearData: { $call: 'portfolio.clearData' },
    portfolio: {
      clearData: { $call: 'clearData' },
      busymode: true,
      id: true,
      referenceCurrency: true,
      currencyExposure: true,
      marketValuesData: true,
      netIncome: {
        onPress: { $call: 'onPress' },
      },
      performanceChartData: true,
      performanceLineChartData: true,
      portfoliosYTDData: true,
      chartAssets: {
        $type: 'list',
        $range: {
          offset: 0,
          length: ref('portfolio.assets.length'),
        },
        $node: {
          category: {
            id: true,
            name: true,
          },
        },
      },
      selectedChartAsset: {
        category: {
          id: true,
          name: true,
        },
      },

      currencyExposure: true,
      ...PortfolioHeader.getFragment('portfolio'),
      ...PortfolioCharts.getFragment('portfolio'),
      ...PortfolioTable.getFragment('portfolio'),
    },
    ui: {
      history: {
        push: { $call: 'push' },
        currentLocation: {
          pathname: true,
        },
      },
      static: {
        portfolio: {
          options: true,
          ...PortfolioTable.getFragment('static'),
        },
      },
      state: {
        portfolio: {
          view: {
            selectedId: true,
          },
          selectedKey: true,
          ascending: true,
          onOptionSelect: { $call: 'changeSort' },
          resetSort: { $call: 'resetSort' },
          chartAssets: {
            setSelected: { $set: 'selectedId' },
          },
          ...PortfolioHeader.getFragment('state'),
        },
      },
    },
    screen: {
      isSmall: true,
      isMedium: true,
    },
    app: {
      user: {
        portfolios: {
          ...PortfolioCharts.getFragment('portfolios'),
          ...PortfolioHeader.getFragment('portfolios'),
        },
        setSelectedPortfolioId: {
          $set: 'selectedPortfolioId',
        },
        selectedPortfolio: true,
        selectedPortfolioData: true,
        setSelectedPortfolioData: {
          $set: 'selectedPortfolioData',
        },
        portfoliosData: true,
        profile: {
          showPmtTxLimitMsg: true,
          paymentTxLimit: true,
          setShowPmtTxLimitMsg: { $set: 'showPmtTxLimitMsg' }
        },
      },
    },
    auth: {
      passwordExpired: true,
      isNonActivePortfolio: true,
      showPaymentLimitAvailable: { $call: 'showPaymentLimitAvailable' },
    },
    rsa: {
      rsaAuthorised: true,
      onChangePage: { $call: 'changePage' },
    },
    i18n: {
      messages: true,
    },
    setRsaPageName: { $set: 'ui.state.rsaPageName' },
    search: {
      clearSearchFilters: { $call: 'clearFilters' },
    },
  },
}, ({ app, ...rest }) => ({
  user: app.user,
  ...rest,
}))(Portfolio);
